type IdentifiableItem = {
  id: string;
};

export type NewToBeReviewedAlertResult<T extends IdentifiableItem> = {
  newItems: T[];
  nextKnownIds: Set<string>;
};

/**
 * Diffs current To Be Reviewed notification items against previously known ids.
 * Returns items that newly appeared and the full updated known-id set.
 */
export const getNewToBeReviewedAlertItems = <T extends IdentifiableItem>(
  knownIds: Set<string>,
  items: T[] = []
): NewToBeReviewedAlertResult<T> => {
  const nextKnownIds = new Set(items.map((item) => item.id));
  const newItems = items.filter((item) => !knownIds.has(item.id));
  return { newItems, nextKnownIds };
};
